import { HistoricalProvidersSummary } from './HistoricalProvidersSummary'
import axios from 'axios'

const base_url = process.env.REACT_APP_BASE_URL || 'http://localhost:5000'

export async function getHistoricalProvidersSummary(
  eocId: string,
  componentId: string
): Promise<HistoricalProvidersSummary[]> {
  const response = await axios.get(
    `${base_url}/api/Lookup/${eocId}/historical-providers`,
    {
      params: { componentId },
    }
  )

  return response.data
}
